import i18n from "../../i18n";

export function translatorf(id) {
    return (i18n.t(id));
}